<template>
  <section>
    <div v-if="loading" class="d-flex justify-content-center align-items-center p-4">
      <Loading color="black" />
    </div>
    <div v-else-if="!loading && schedule.length" class="schedule-collapse">
      <div v-for="(day, index) in schedule"
           :key="day.id"
           class="schedule-collapse__slot"
      >
        <button
          v-b-toggle="`${day.id}-${day.date.replace(' ', '-').toLowerCase()}`"
          class="schedule-collapse__slot__button"
        >
          <span class="day-arrow"><CollapseArrow /></span>
          <span class="day-title">{{ day.name }} — {{ day.date }}</span>
        </button>

        <b-collapse
          :id="`${day.id}-${day.date.replace(' ', '-').toLowerCase()}`"
          :visible="index == 0 ? true : false"
        >
          <div class="schedule-slots">
            <ul class="schedule-slots__list">
              <template v-for="slot in day.scheduleItem">
                <li
                  v-if="slot.name != 'Movement Ident'"
                  :key="slot.id"
                  class="schedule-slots__list__item"
                >
                  <template v-if="isValidUrl(slot.url)">
                    <router-link
                      v-if="slot.url"
                      class="schedule-link"
                      :to="{ path: formatUrl(slot.url) }"
                    >
                      <span class="time-slot">{{ formatDateToTime(slot.starts) }}</span>
                      <span
                        class="title-slot"
                        :class="{ isplaying: isSlotLive(slot.starts, slot.ends) }"
                        v-html="slot.name"
                      />
                    </router-link>
                  </template>
                  <template v-else>
                    <div class="schedule-row">
                      <span class="time-slot">{{ formatDateToTime(slot.starts) }}</span>
                      <span
                        class="title-slot"
                        :class="{ isplaying: isSlotLive(slot.starts, slot.ends) }"
                        v-html="slot.name"
                      />
                    </div>
                  </template>
                </li>
              </template>
            </ul>
          </div>
        </b-collapse>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import {BCollapse} from 'bootstrap-vue';
import CollapseArrow from '@/components/svg/CollapseArrow.vue';
import Loading from '@/components/ui/Loading.vue';

export default {
  name: 'ScheduleTabPane',
  components: {BCollapse, CollapseArrow, Loading},
  props: {
    liveChannel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    schedule: [],
    radioClock: moment().format('YYYY-MM-DD HH:mm:ss'),
    timezone: null,
    loading: false
  }),
  mounted() {
    this.getSchedule();
    this.initClock();
  },
  methods: {
    initClock() {
      setInterval(() => {
        this.radioClock = moment().format('YYYY-MM-DD HH:mm:ss');
      }, 60 * 1000); // check every minute ehich show is live
    },
    formatDateToTime(date) {
      return moment(date).format('HH:mm');
    },
    isSlotLive(starts, ends) {
      return starts < this.radioClock && ends > this.radioClock;
    },
    formatUrl(url) {
      const path = new URL(url);
      return path.pathname;
    },
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    getSchedule() {
      this.loading = true;
      axios
          .get(
              `${this.liveChannel.baseURL}/api/week-info?timezone=` +
              Intl.DateTimeFormat().resolvedOptions().timeZone
          )
          .then(response => {
            var takecity = Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.split('/');
            this.timezone = takecity[1];
            var weekday = new Array(14);
            var d = new Date();
            weekday[0] = 'sunday';
            weekday[1] = 'monday';
            weekday[2] = 'tuesday';
            weekday[3] = 'wednesday';
            weekday[4] = 'thursday';
            weekday[5] = 'friday';
            weekday[6] = 'saturday';
            weekday[7] = 'sunday';
            weekday[8] = 'monday';
            weekday[9] = 'tuesday';
            weekday[10] = 'wednesday';
            weekday[11] = 'thursday';
            weekday[12] = 'friday';
            weekday[13] = 'saturday';
            var i;
            let index = -1;
            var convertsunday;
            d.getDay() == 0 ? (convertsunday = 7) : (convertsunday = d.getDay());

            for (i = convertsunday; i < convertsunday + 7; i++) {
              var finaldate;
              i <= 7 ? (finaldate = weekday[i]) : (finaldate = 'next' + weekday[i]);
              var sheduleobj = response.data[finaldate];
              index++;
              var obj = {
                name: weekday[i],
                id: weekday[i],
                scheduleItem: sheduleobj,
                date: moment()
                    .add(index, 'days')
                    .format('DD MMMM')
                    .toUpperCase()
              };
              this.schedule.push(obj);
              this.schedule[0].name = 'Today';
              this.loading = false;
            }
          })
          .catch(error => {
            console.error(error);
          });
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_schedule-tab-pane.scss';
</style>
